import { apiFetchBlob } from './api-client';

/**
 * fb#580 — ทะเบียน + เลขบัญชีเป็น CSV เปิดในชีต/Excel แล้วเลข 0 ตัวหน้าหาย (ชีตเดาว่าเป็นตัวเลข)
 * → อ่าน CSV ชุดเดิมจากเซิร์ฟเวอร์เป็นข้อความล้วน แล้วเขียน .xlsx ที่ทุกช่องเป็น "ข้อความ" (@)
 * เลขบัญชี/เลขบัตร/เบอร์โทรจึงครบทุกหลัก ไม่มีสัญลักษณ์แทรก
 */
export async function downloadRegistryXlsx(
  endpoint: string,
  filename: string,
  // fb#600 ไฟล์โอนเงินใช้ตัวเดียวกัน — ชื่อแผ่นงาน + คอลัมน์ที่ต้องเป็นตัวเลข (ยอดเงินให้ Excel รวมได้)
  opts: { sheetName?: string; numericCols?: number[] } = {},
): Promise<void> {
  const text = (await (await apiFetchBlob(endpoint)).text()).replace(/^﻿/, '');
  const XLSX = await import('xlsx');
  const ws = XLSX.read(text, { type: 'string', raw: true }).Sheets.Sheet1!;
  const range = XLSX.utils.decode_range(ws['!ref'] ?? 'A1');
  for (let r = range.s.r; r <= range.e.r; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (!cell) continue;
      const n = Number(cell.v);
      if (r > range.s.r && opts.numericCols?.includes(c) && String(cell.v ?? '').trim() !== '' && Number.isFinite(n)) {
        cell.t = 'n'; cell.v = n; cell.z = '#,##0.00';
      } else {
        cell.t = 's'; cell.v = String(cell.v ?? ''); cell.z = '@';
      }
    }
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, opts.sheetName ?? 'ทะเบียนพนักงาน');
  XLSX.writeFile(wb, filename);
}
